import Loading from 'Components/Loading';
import { checkNotification } from 'JS/API';
import { useState } from 'react';
import { TfiClose } from "react-icons/tfi";

const ProductInputModal = ({
    setIsDirectOpen,
    productItemList,
    setProductItemList,
    selectedItem,
    setNoneProduct,
    setIsClassLocked,
    noneProduct
}) => {
    const [input, setInput] = useState('');
    const [isLoading, setIsLoading] = useState(false); // 로딩 상태 추가

    const directInputSave = async () => {
        if (isLoading) return; 

        if (!input.trim()) {
            alert('상품명을 입력해주세요.');
            return;
        }

        const newProduct = {
            kind_code: selectedItem?.kind_code || '',
            product: input.trim(),
        };

        const isDuplicate = productItemList.some(
            (item) =>
                item.product === newProduct.product &&
                item.kind_code === newProduct.kind_code
        );

        const isNoneDuplicate = noneProduct.some(
            (item) =>
                item.product === newProduct.product &&
                item.kind_code === newProduct.kind_code
        );
        
        if (isDuplicate || isNoneDuplicate) {
            alert('이미 등록된 상품입니다.');
            return;
        }

        try {
            setIsLoading(true); // 요청 시작
            const res = await checkNotification({
                mark_class: newProduct.kind_code,
                product_name: newProduct.product,
            });

            const {
                exists_in_all_class,
                matched_class,
                exists_in_target_class,
            } = res?.data || {};

            if (!exists_in_all_class) {
                alert('비고시상품입니다.');
                setNoneProduct((prev) => [...prev, newProduct]);
                setIsClassLocked(true);
            }

            if (exists_in_target_class) {
                alert('해당 분류에 존재하는 고시상품입니다.');
                setProductItemList((prev) => [...prev, newProduct]);
                setIsClassLocked(true);
            } else if (exists_in_all_class && !exists_in_target_class && matched_class) {
                const confirmAdd = window.confirm(
                    `${matched_class}류에 해당하는 고시 상품입니다. 그래도 넣으시겠습니까?`
                );
                if (!confirmAdd) return;

                setNoneProduct((prev) => [...prev, newProduct]);
                setIsClassLocked(true);
            }

            setInput('');
            setIsDirectOpen(false);
        } catch (err) {
            console.error('상품 확인 중 오류:', err);
            alert('상품 확인 중 오류가 발생했습니다.');
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div className="modal-bg">
            <div className="modal column">
                <div className="head">
                    <h3>직접 입력하여 상품 추가</h3>
                    <div className="personnel-modal-close"
                        onClick={() => setIsDirectOpen(false)}
                    >
                        <TfiClose />
                    </div>
                </div>
                <hr />
                <div className="row input-section">
                    <span>상품 :</span>
                    <input
                        type="text"
                        className="common-text-input"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                directInputSave();
                            }
                        }}
                    />
                </div>
                <div className="btn-wrap row side">
                    <button
                        className="gradient-btn"
                        onClick={directInputSave}
                        disabled={isLoading}
                    >
                        추가
                    </button>

                    <button
                        className="gray-btn"
                        onClick={() => {
                            setInput('');
                            setIsDirectOpen(false);
                        }}>
                        취소
                    </button>
                </div>
            </div>
            {isLoading && (
                <Loading />
            )}
        </div>
    );
};

export default ProductInputModal;
